const { gql } = require('@apollo/client')

const StoreFragment = gql`
  fragment Store on Store {
    id
    address
    countryCode
    email
    latitude
    longitude
    phoneNumber
    region
    storeName
    storeType
    storeManagerId
  }
`

export { StoreFragment }
